import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { EQM1030_R01Dto, EQM1030_R01ChartData } from "./Dto_EQM1030_R01";
import { formatDate } from "src/utils/string/stringUtil";
import { EQM1030_R01Filter } from "./Store_EQM1030_R01";

const baseUrl = `${config.apiUrl}/EQM1030_R01`;

/**
 * Filter를 API 파라미터로 변환
 */
export const getParams = (filter: EQM1030_R01Filter) => {
    const params = {
        compCd: filter.compCd || undefined,
        date: filter.baseDate ? formatDate(filter.baseDate) : undefined,
    };
    return params;
};

/**
 * 최신 '설정/현재' 매칭 목록 조회
 * @param option - 'refetch' 또는 빈 문자열
 * @param filter - 조회 조건
 * @param listLength - 조회 건수 제한 힌트
 * @param view - 'CHART', 'TABLE', 'ALL' (기본값: undefined)
 */
export const getEQM1030_R01List = async (
    option: string = "",
    filter: EQM1030_R01Filter,
    listLength: number = 0,
    view?: string
) => {
    const url = option ? `${baseUrl}/${option}` : baseUrl;
    const params = {
        ...getParams(filter),
        listLength: listLength || undefined,
        view: view || undefined,
    };
    return await getData<ResponseDto<EQM1030_R01Dto[]>>(url, { params });
};

/**
 * Chart 데이터 조회
 * @param filter - 조회 조건
 * @param option - 'refetch' 또는 빈 문자열
 * @param listLength - 조회 건수 제한 힌트
 */
export const getEQM1030_R01ChartData = async (
    filter: EQM1030_R01Filter,
    option: string = "",
    listLength: number = 0
) => {
    const url = option ? `${baseUrl}/${option}` : baseUrl;
    const params = {
        ...getParams(filter),
        listLength: listLength || undefined,
        view: 'CHART', // CHART 뷰로 조회
    };
    return await getData<ResponseDto<EQM1030_R01ChartData[]>>(url, { params });
};

/**
 * 엑셀 다운로드(Base64)
 * @param option - 'search' 또는 빈 문자열
 * @param filter - 조회 조건
 * @param listLength - 조회 건수 제한 힌트
 */
export const exportEQM1030_R01Excel = async (
    option: string = "",
    filter: EQM1030_R01Filter,
    listLength: number = 0
) => {
    const url = option ? `${baseUrl}/excel/${option}` : `${baseUrl}/excel`;
    const params = {
        ...getParams(filter),
        listLength: listLength || undefined,
    };
    return await getData<ResponseDto<string>>(url, { params });
};


